import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CardOnFile } from '../card-on-file';
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from 'src/app/shared/login/login-service/login.service';
import { LoginState } from 'src/app/shared/login/login-service/login-state.interface';
import { View } from './view.enum';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
    selector: 'ols-existing-client',
    templateUrl: './existing-client.component.html',
    styleUrls: ['./existing-client.component.scss'],
})
export class ExistingClientComponent implements OnInit, OnDestroy {
    @Input() purchaseAgreement: string;
    @Input() surchargeSettings: {
        surchargeEnabled: boolean;
        surchargeRate: number;
    };
    @Input() isLoading: boolean;

    private _cardsOnFile: CardOnFile[];
    public get cardsOnFile(): CardOnFile[] {
        return this._cardsOnFile;
    }
    @Input() public set cardsOnFile(value: CardOnFile[]) {
        this._cardsOnFile = value;

        if (!value) {
            this.isLoadingCardsOnFile = true;
            this.changeShownView(this.View.CARDS_ON_FILE);
        } else if (value.length > 0) {
            this.changeShownView(this.View.CARDS_ON_FILE);
            this.isLoadingCardsOnFile = false;
        } else {
            this.isLoadingCardsOnFile = false;
            this.changeShownView(this.View.ADD_CARD);
        }
    }

    public isLoggedIn = false;
    public View = View;
    public shownView: View = View.CARDS_ON_FILE;
    public clientFullName: string;
    private ngUnsubscribe: Subject<any> = new Subject();
    public isLoggingIn = false;
    public isLoadingCardsOnFile = false;

    constructor(
        private loginService: LoginService,
        private readonly configService: ConfigService
    ) {}

    ngOnInit(): void {
        this.loginService.loginState$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (updatedState: LoginState) => {
                    this.isLoggedIn = updatedState?.userAccountGuid?.length > 0;
                    this.isLoggingIn = updatedState?.isLoggingIn;
                    this.changeShownView(this.View.CARDS_ON_FILE);
                    if (this.isLoggedIn) {
                        this.clientFullName =
                            updatedState.firstName +
                            ' ' +
                            updatedState.lastName;
                    }
                },
                (_err) => {
                    this.isLoggedIn = false;
                    return of(null);
                }
            );
    }

    public logout(): void {
        this.loginService.logOut();
        this.removeTokensFromClientAuthFrontendCookies();
    }

    private removeTokensFromClientAuthFrontendCookies() {
        const customerID = localStorage.getItem('Customer_ID');
        const origin = this.configService.config.clientAuthUrl;
        const url = `${origin}?customerID=${customerID}&removeExistingTokens=1`;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
    }

    changeShownView(shownView: View): void {
        this.shownView = shownView;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
